import React, { useState, useEffect, useRef} from 'react';
import { Col, Row } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../Pages/Constants';
import RequestsSent from '../Components/Shares/RequestsSent.js';
import CreationRequestsGetter from '../Controller/getSQLCreationRequestsFunctions.js';
import {FormattedMessage} from 'react-intl';

const SentInvitationsMenu = (props) => {

    const [requests_List, setRequestsList] = useState([]);
    const requestsListRef = useRef();
    requestsListRef.current = requests_List;

    useEffect(() => {
        props.reloadUserAndProfiles();
        retrieveRequestsList();
    },  
    //eslint-disable-next-line
    []);

    const retrieveRequestsList = async () => {

        // PSAD-style user-to-user pending invitations (legacy flow)
        let local_Requests_List = await CreationRequestsGetter.get_requests_sent_list();
        if (!Array.isArray(local_Requests_List)) local_Requests_List = [];
        // Annotate so ItemListSentRequest can branch on item_type
        local_Requests_List = local_Requests_List.map(r => ({ ...r, item_type: 'psad' }));

        // Structure-share invitations (pending + accepted)
        const structure = await CreationRequestsGetter.get_sent_structure_invitations();
        const pending = (structure && structure.pending) || [];
        const accepted = (structure && structure.accepted) || [];

        const merged = [...local_Requests_List, ...pending, ...accepted];
        setRequestsList(merged);
    };

    const { classes } = props;

    /**Component generating two tabs*/
    return (
        <div className={classes.popup_background}>
            <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                <div className="management-menu-popup">
                    <Row className="justify-content-md-end" style = {{ height: "5%", paddingBottom: "20px" }}>
                        <Col style={{ fontWeight: "bold", fontSize:"2.2em" }}>
                            <center>
                                <FormattedMessage id="invitation.title" defaultMessage="Invitations" />
                            </center>
                        </Col>
                    </Row>
                    <Row style={{overflowY:"auto", height: '90%'}}>
                        <RequestsSent requests_List={requests_List} structure_Id={props.structure_Id} retrieveRequestsList={retrieveRequestsList}/>
                    </Row>
                    <Row>
                        <center>
                            <button onClick={props.cancelPopup} className="btn btn-danger">
                                <FormattedMessage id="button.close" defaultMessage="Close" />                                           
                            </button>
                        </center>
                    </Row>
                </div>
            </div>
        </div>
    );
};
export default withStyles(Constants.styles)(SentInvitationsMenu);